<template>
  <v-container
    fluid
    grid-list-lg
  >
    <NotPermission v-if="!$can('list', 'Registereds')" />
    <template>
      <Breadcrumbs
        :routes="[
          { name: 'Inicio', to: { name: 'descargapagos' } },
          { name: 'Listado' }
        ]"
      />
      <v-card>
        <v-toolbar
          color="grey darken-4"
          dark
          card
        >
          <v-toolbar-title>Descarga de pagos</v-toolbar-title>
          <v-spacer />
          <template v-if="$can('list', 'Cepre')">
            <div class="my-2">
              <v-btn
                block
                color="success"
                @click="DownloadExcel"
              >
                Listado de Examenes
              </v-btn>
            </div>
          </template>
        </v-toolbar>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              v-if="typeExams.length"
              sm6
              offset-sm6
            >
              <v-text-field
                v-model="searchUsers"
                :disabled="loadingTypeexams"
                box
                append-icon="search"
                label="Buscar"
                clearable
                hide-details
              />
            </v-flex>
            <v-flex xs12>
              <v-data-table
                :headers="[
                  { text: 'Nombre', value: 'name' },
                ]"
                :items="typeExams"
                :search="searchUsers"
                :loading="loadingRegisteredsCepre"
                class="elevation-1"
              >
                <tr
                  slot="items"
                  slot-scope="props"
                >
                  <td class="px-3">
                    {{ props.item.title }}
                  </td>
                  <td>
                    <v-btn
                      color="blue-grey"
                      class="ma-2 white--text"
                      @click="descargar(props.item)"
                    >
                      Descarga total
                      <v-icon
                        right
                        dark
                      >
                        cloud_download
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <ModalPayments />
      <ModalAbility />
      <ModalDeleteInscribed />
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { format } from 'date-fns'

export default {
  middleware: 'auth',
  metaInfo () {
    return { title: 'Listado de inscritos' }
  },
  components: {
    NotPermission: () => import('@/views/errors/NotPermission'),
    Breadcrumbs: () => import('@/components/Breadcrumbs'),
    ModalAbility: () => import('@/views/registereds/ModalAbility'),
    ModalDeleteInscribed: () =>
      import('@/views/registereds/ModalDeleteInscribed'),
    ModalPayments: () => import('@/views/cepre/ModalPayments')
  },
  data () {
    return {
      searchUsers: '',
      excel_path: ''
    }
  },
  computed: {
    ...mapState({
      typeExams: state => state.typeExams.typeexams
    })
  },
  created () {
  	this.getExams()
  },
  methods: {
    ...mapActions({
      getExams: 'typeExams/getExamsEnabled',
	    getFullDownload: 'typeExams/getFullDownload'
    }),
    descargar (item) {
      // console.log(item);
      this.getFullDownload({ id: item.id })
        .then(response => {
        // console.log(response.headers.entries());
        // console.log(response.entries());
          return response.blob()
        })
        .then(response => {
          const data = response.data
          const link = document.createElement('a')
          const hoy = new Date()

          // link.href = `data:application/zip;base64,${data}`
          link.href = URL.createObjectURL(response)
          // `data:application/zip;base64,${data}`
          // link.download = 'descarga.zip'
          link.download = `pagos-${item.title}--${format(hoy, 'yyyy-MM-dd')}__${format(hoy, 'hh-mm-ss')} .zip`
          link.click()
        }).catch(err => {
          console.log(err)
        })
    },

    DownloadExcel () {
      this.getReportExcel().then(response => {
        const Excel = response.data
        this.Download(Excel)
      })
    },
    Download (Excel) {
      const url = Excel.excel_path
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'inscritos.xls')
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
